{
    "SectionheaderDatetime": "Data \/ Ora",
    "SectionheaderTimerange": "Intervallo di tempo",
    "SectionheaderDaterange": "Intervallo data\/ora personalizzato",
    "SectionheaderDaysoftheweek": "Giorni della settimana",
    "InputlabelBetween": "Tra:",
    "InputlabelAnd": "E:",
    "RadiolabelRealtime": "Tempo reale (ora)",
    "RadiolabelToday": "Oggi",
    "RadiolabelYesterday": "Ieri",
    "RadiolabelThisweek": "Questa settimana",
    "RadiolabelLastweek": "La scorsa settimana",
    "RadiolabelThismonth": "Questo mese",
    "RadiolabelLastmonth": "Il mese scorso",
    "RadiolabelCustom": "Personalizzato...",
    "RadiolabelDays": "Giorni:",
    "NAME": "DateTime",
    "SectionHeaderLastXDays": "Ultimi 'X' giorni",
    "RadiolabelLastXDays": "Ultimi 'X' giorni"
}